import React, { Component } from 'react';
import { SaveButton, DeleteButton } from '../modalButtons';

const cardStyle = {
	background: '#fff',
	border: '1px solid #e0e6ef',
	borderRadius: '8px',
	boxShadow: '0 4px 16px rgba(0,0,0,0.13)',
	padding: '20px',
	display: 'flex',
	flexDirection: 'column'
};

const modalLabelStyle = {
	display: 'block',
	fontSize: '12px',
	color: '#888',
	marginBottom: '6px',
	fontWeight: '700',
	textTransform: 'uppercase',
	letterSpacing: '0.5px'
};

class KnowledgeBase extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editingEntry: false,
			parseLoading: false,
			fileDragOver: false,
			searchQuery: '',
			error: ''
		};
		this.fileInputRef = React.createRef();
		this._spinStyle = null;
	}

	componentDidMount() {
		var style = document.createElement('style');
		style.id = 'kb-anim';
		style.textContent = '@keyframes kbSpin{to{transform:rotate(360deg)}}';
		document.head.appendChild(style);
		this._spinStyle = style;
	}

	componentWillUnmount() {
		if (this._spinStyle) this._spinStyle.remove();
	}

	componentWillReceiveProps(nextProps) {
		var nextParsed = nextProps.data.KnowledgeBase && nextProps.data.KnowledgeBase._parsedFile;
		var prevParsed = this.props.data.KnowledgeBase && this.props.data.KnowledgeBase._parsedFile;
		if (nextParsed && (!prevParsed || nextParsed.ts !== prevParsed.ts)) {
			this.setState(function(s) {
				var entry = Object.assign({}, s.editingEntry || {});
				entry.content = nextParsed.text;
				if (!entry.name) entry.name = nextParsed.fileName.replace(/\.[^.]+$/, '');
				return { editingEntry: entry, parseLoading: false };
			});
		}
	}

	cancel = () => {
		this.setState({ editingEntry: false, parseLoading: false, fileDragOver: false, error: '' });
	}

	openAddEntry = () => {
		this.setState({ editingEntry: { _isNew: true, _entryId: '', name: '', content: '' }, error: '' });
	}

	openEditEntry = (entryId, entry) => () => {
		this.setState({ editingEntry: { ...JSON.parse(JSON.stringify(entry)), _entryId: entryId, _originalName: entry.name }, error: '' });
	}

	editField = (field) => (e) => {
		var entry = Object.assign({}, this.state.editingEntry);
		entry[field] = e.target.value;
		this.setState({ editingEntry: entry });
	}

	saveEntry = () => {
		var entry = this.state.editingEntry;
		if (!entry.name || !entry.name.trim()) { this.setState({ error: 'Please enter a name.' }); return; }
		if (!entry.content || !entry.content.trim()) { this.setState({ error: 'Please enter some content.' }); return; }
		var entryId = entry._entryId || entry.name.toLowerCase().replace(/[^a-z0-9]/g, '');
		var toSave = { name: entry.name, content: entry.content };
		this.props.ws.send(JSON.stringify({ route: 'saveKnowledgeEntry', entryId: entryId, entry: toSave }));
		this.setState({ editingEntry: false, error: '' });
	}

	regenContent = () => {
		var entry = this.state.editingEntry;
		if (!entry.content || !entry.content.trim()) { this.setState({ error: 'No content to regenerate.' }); return; }
		this.setState({ parseLoading: true, error: '' });
		this.props.ws.send(JSON.stringify({ route: 'regenKnowledgeContent', content: entry.content, entryName: entry.name }));
	}

	handleFile = (file) => {
		if (!file) return;
		if (file.size > 10 * 1024 * 1024) { this.setState({ error: 'File is too large. Maximum size is 10 MB.' }); return; }
		this.setState({ parseLoading: true, error: '' });
		var reader = new FileReader();
		reader.onload = (e) => {
			var base64 = e.target.result.split(',')[1];
			this.props.ws.send(JSON.stringify({ route: 'parseKnowledgeFile', fileName: file.name, fileData: base64 }));
		};
		reader.readAsDataURL(file);
	}

	onFileDrop = (e) => {
		e.preventDefault();
		this.setState({ fileDragOver: false });
		var file = e.dataTransfer.files && e.dataTransfer.files[0];
		if (file) this.handleFile(file);
	}

	onFileInput = (e) => {
		var file = e.target.files && e.target.files[0];
		if (file) this.handleFile(file);
		e.target.value = '';
	}

	render() {
		if (!this.props.active) return <div style={{ width: '100%' }}></div>;

		var entries = Object.assign({}, this.props.data.KnowledgeBase || {});
		delete entries._parsedFile;
		var bots = (this.props.data.AIChatbots && this.props.data.AIChatbots.bots) || {};
		var allEntries = Object.entries(entries);
		var searchQuery = this.state.searchQuery.toLowerCase().trim();
		var entryList = searchQuery
			? allEntries.filter(function([id, e]) {
				return e.name.toLowerCase().includes(searchQuery) || (e.content || '').toLowerCase().includes(searchQuery);
			})
			: allEntries;

		var clickableCard = { ...cardStyle, cursor: 'pointer', transition: 'box-shadow 0.15s, border-color 0.15s' };
		var TOKEN_WARN = 1500;

		// ── Entry Cards ────────────────────────────────────────────────────
		var entryCards = entryList.map(function([entryId, entry]) {
			var tokens = Math.round((entry.content || '').length / 4);
			var tokenWarn = tokens > TOKEN_WARN;
			var usingBots = Object.values(bots).filter(function(b) { return (b.knowledgeIds || []).indexOf(entryId) > -1; });
			return (
				<div key={entryId} onClick={this.openEditEntry(entryId, entry)} style={{ ...clickableCard, flex: '1 1 280px', minWidth: '240px', maxWidth: '380px' }}>
					<div style={{ fontWeight: '700', fontSize: '15px', color: '#002f5f', marginBottom: '10px' }}>{entry.name}</div>
					<div style={{
						color: '#666', fontSize: '13px', lineHeight: '1.6', flex: 1,
						overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical',
						whiteSpace: 'pre-wrap'
					}}>{entry.content}</div>
					{usingBots.length > 0 && (
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '10px' }}>
							{usingBots.map(function(b) {
								return (
									<span key={b.name} style={{ background: '#e8f0fa', color: '#2A6AA9', borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: '600' }}>{b.name}</span>
								);
							})}
						</div>
					)}
					<div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
						<span style={{ fontSize: '12px', color: tokenWarn ? '#e67e22' : '#aaa', fontWeight: tokenWarn ? '600' : 'normal' }}>
							{tokens} est. tokens
						</span>
						{tokenWarn && (
							<span style={{ fontSize: '11px', background: '#fff4e6', color: '#e67e22', borderRadius: '4px', padding: '1px 6px', fontWeight: '600' }}>Large</span>
						)}
					</div>
				</div>
			);
		}.bind(this));

		var addCard = (
			<div
				onClick={this.openAddEntry}
				style={{
					...cardStyle,
					flex: '1 1 280px', minWidth: '240px', maxWidth: '380px',
					border: '2px dashed #c8d8ea', boxShadow: 'none',
					alignItems: 'center', justifyContent: 'center',
					cursor: 'pointer', color: '#2A6AA9', minHeight: '160px',
					transition: 'border-color 0.2s, background 0.2s'
				}}
			>
				<div style={{ fontSize: '32px', lineHeight: 1, marginBottom: '8px' }}>+</div>
				<div style={{ fontWeight: '600', fontSize: '14px' }}>Add Entry</div>
			</div>
		);

		// ── Entry Modal ────────────────────────────────────────────────────
		var entryModal = this.state.editingEntry ? (() => {
			var e = this.state.editingEntry;
			var isNew = e._isNew;
			return (
				<div className="blackout" tabIndex="1" autoFocus>
					<div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '600px', maxWidth: '95vw', padding: '0', position: 'relative', overflow: 'hidden' }}>
						<div className="viewCloser" onClick={this.cancel}></div>
						<div style={{ background: '#002f5f', padding: '24px 32px', color: '#fff' }}>
							<div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', marginBottom: '4px' }}>Knowledge Base</div>
							<div style={{ fontSize: '22px', fontWeight: '700' }}>{isNew ? 'Add Entry' : (e._originalName || e.name)}</div>
						</div>
						<div style={{ padding: '28px 32px 32px', overflowY: 'auto', maxHeight: 'calc(60vh - 80px)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

						<div className="snazzyInputBox" style={{ width: '100%' }}>
							<input className="textInput" type="text" required value={e.name || ''} onChange={this.editField('name')} />
							<span className="inputBar"></span>
							<label className="textLabel">Entry Name</label>
						</div>

						{/* File upload zone */}
						<div style={{ width: '100%', marginBottom: '16px' }}>
							<label style={modalLabelStyle}>Import from File</label>
							<div
								onDragOver={(ev) => { ev.preventDefault(); this.setState({ fileDragOver: true }); }}
								onDragLeave={() => this.setState({ fileDragOver: false })}
								onDrop={this.onFileDrop}
								onClick={() => !this.state.parseLoading && this.fileInputRef.current && this.fileInputRef.current.click()}
								style={{
									border: '2px dashed ' + (this.state.fileDragOver ? '#2A6AA9' : '#c8d8ea'),
									borderRadius: '8px',
									padding: '20px',
									textAlign: 'center',
									cursor: this.state.parseLoading ? 'default' : 'pointer',
									background: this.state.fileDragOver ? '#f0f6ff' : '#fafbfc',
									transition: 'border-color 0.15s, background 0.15s'
								}}
							>
								{this.state.parseLoading ? (
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', color: '#2A6AA9' }}>
										<span style={{ width: '16px', height: '16px', border: '2px solid #c0d4ee', borderTopColor: '#2A6AA9', borderRadius: '50%', display: 'inline-block', animation: 'kbSpin 0.7s linear infinite', flexShrink: 0 }} />
										<span style={{ fontSize: '13px', fontWeight: '600' }}>Extracting &amp; cleaning with AI...</span>
									</div>
								) : (
									<div>
										<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2A6AA9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', margin: '0 auto 8px', opacity: 0.6 }}>
										<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
										<polyline points="14 2 14 8 20 8"/>
										<line x1="16" y1="13" x2="8" y2="13"/>
										<line x1="16" y1="17" x2="8" y2="17"/>
									</svg>
										<div style={{ fontSize: '13px', fontWeight: '600', color: '#2A6AA9', marginBottom: '2px' }}>Drop a file here or click to browse</div>
										<div style={{ fontSize: '12px', color: '#aaa' }}>.txt &middot; .csv &middot; .pdf &middot; .docx &middot; .xlsx &mdash; max 10 MB</div>
									</div>
								)}
							</div>
							<input ref={this.fileInputRef} type="file" accept=".txt,.csv,.pdf,.docx,.xlsx,.xls" style={{ display: 'none' }} onChange={this.onFileInput} />
						</div>

						<div style={{ width: '100%', marginBottom: '14px' }}>
							<label style={modalLabelStyle}>Content</label>
							<textarea
								value={e.content || ''}
								onChange={this.editField('content')}
								rows={12}
								style={{ width: '100%', padding: '10px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'sans-serif', lineHeight: '1.6' }}
								placeholder={'Paste the information bots should know, or import a file above.\n\nExample:\n\nBusiness Hours:\nMonday\u2013Friday: 5am\u201311pm\nSaturday: 6am\u201310pm\nSunday: 7am\u20139pm'}
							/>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '6px' }}>
								<div style={{ fontSize: '12px', color: '#aaa' }}>
									Injected into the bot's context when this entry is selected.
									{e.content ? (() => { var t = Math.round(e.content.length / 4); return <span style={{ color: t > 1500 ? '#e67e22' : '#aaa', fontWeight: t > 1500 ? '600' : 'normal' }}> {t} est. tokens{t > 1500 ? ' — consider trimming' : ''}</span>; })() : ''}
								</div>
								{e.content && !this.state.parseLoading && (
									<button onClick={this.regenContent} style={{ background: 'none', border: '1px solid #c8d8ea', borderRadius: '6px', padding: '4px 12px', fontSize: '12px', fontWeight: '600', color: '#2A6AA9', cursor: 'pointer', flexShrink: 0, marginLeft: '12px' }}>
										Re-generate with AI
									</button>
								)}
							</div>
						</div>

						<div className="error">{this.state.error}</div>
						<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
							{!isNew && <DeleteButton onClick={function() { this.props.ws.send(JSON.stringify({ route: 'deleteKnowledgeEntry', entryId: e._entryId })); this.cancel(); }.bind(this)} />}
							<SaveButton onClick={this.saveEntry}>{isNew ? 'Add Entry' : 'Save'}</SaveButton>
						</div>
						</div>
					</div>
				</div>
			);
		})() : '';


		// ── Page ───────────────────────────────────────────────────────────
		return (
			<div style={{ padding: '20px', overflowY: 'auto', height: '100%', boxSizing: 'border-box' }}>

				<div style={{ display: 'flex', alignItems: 'center', marginBottom: '14px', gap: '14px' }}>
					<div style={{ fontWeight: '700', fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase', color: '#888', flexShrink: 0 }}>Knowledge Entries</div>
					{allEntries.length > 0 && (
						<input
							type="text"
							value={this.state.searchQuery}
							onChange={(e) => this.setState({ searchQuery: e.target.value })}
							placeholder="Search entries..."
							style={{ flex: 1, maxWidth: '300px', padding: '6px 12px', border: '1px solid #dde3ea', borderRadius: '6px', fontSize: '13px', outline: 'none' }}
						/>
					)}
					{allEntries.length > 0 && (
						<div style={{ fontSize: '12px', color: '#aaa', marginLeft: 'auto', flexShrink: 0 }}>
							{searchQuery ? entryList.length + ' of ' + allEntries.length : allEntries.length} {allEntries.length === 1 ? 'entry' : 'entries'}
						</div>
					)}
				</div>

				{entryList.length === 0 && (
					<div style={{ textAlign: 'center', color: '#aaa', fontSize: '14px', marginTop: '60px' }}>
						<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', margin: '0 auto 14px' }}>
					<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
					<polyline points="14 2 14 8 20 8"/>
					<line x1="16" y1="13" x2="8" y2="13"/>
					<line x1="16" y1="17" x2="8" y2="17"/>
				</svg>
						<div style={{ fontWeight: '600', marginBottom: '6px' }}>No knowledge entries yet</div>
						<div style={{ fontSize: '13px' }}>Add entries to give your bots facts about hours, fares, routes, and more.</div>
					</div>
				)}

				<div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
					{entryCards}
					{addCard}
				</div>

				{entryModal}
			</div>
		);
	}
}

const icon = "menuObject";
const roles = ["View", "Add", "Edit", "Delete"];
export { KnowledgeBase, icon, roles };
